export default __webpack_public_path__ + "static/media/professor.953af43f.png";